module Meevo.Components.AiChat {

    export interface IAiChatCallbacks {
        onClose(): void;
        onMinimize(): void;
        onReattach(): void;
    };

    export class AiChatModalController {
        static $inject = [
            "$rootScope",
            "options",
            "callbacks",
            "$timeout",
            "meevo.components.aichat.AiChatService"
        ];
        private localStorageKey: string = 'meevo2.ai-chat';
        private resizeHandle: HTMLElement;
        private isResizing: boolean = false;
        MIN_HEIGHT = 100;

        constructor(private $rootScope: ng.IRootScopeService,
            public options: Meevo.Components.AiChat.IAiChatOptions,
            public callbacks: Meevo.Components.AiChat.IAiChatCallbacks,
            public $timeout: angular.ITimeoutService,
            private aiChatService: Meevo.Components.AiChat.IAiChatService
            ) {
                $rootScope.$on(Meevo.Components.Common.Messages.OPEN_AICHAT_COMPLETE, (event, args) => {
                    this.setStartingPosition();
                });

                $rootScope.$on(Meevo.Components.Common.Messages.DETACH_AICHAT, (event, args) => {
                    this.setStartingPosition();
                });
        }

        $onInit() {
            setTimeout(() => {
                var el = $('md-dialog')[0];
                el.id = 'ai-chat-modal';
                this.makeDialogDraggable('ai-chat-modal');
                this.enableTouchSupport(el);
            }, 500)

            setTimeout(() => {
                this.setStartingPosition();
                this.resizeHandle = $('#ai-resize-handle')[0];
                this.addResizeListeners();
                this.enableTouchSupport(this.resizeHandle);
                this.aiChatService.attachTo(AiChatService.MODAL_HOST_ID);
            }, 1);
        }

        toggleDetached(): void {
            if (this.callbacks.onReattach) {
                this.callbacks.onReattach();
            }
        }

        minimizeMenu(): void {
            if (this.callbacks.onMinimize) {
                this.callbacks.onMinimize();
            }
        }

        closeMenu(): void {
            if (this.callbacks.onClose) {
                this.callbacks.onClose();
            }
        }

        adjustDialogPositionAndSize(dialog: any) : void {

            // Get the bounding rectangle and inset of the dialog
            if (!dialog) return;
            let rect = dialog.getBoundingClientRect();
            let inset = window.getComputedStyle(dialog)["inset"].split(' ');

            // Adjust the inset and size of the dialog to prevent it from going off the screen
            if (rect.left < 0) inset[3] = '0px';
            if (rect.top < 0) inset[0] = '0px';
            if (rect.right > window.innerWidth) {
                let overflowWidth = rect.right - window.innerWidth;
                inset[3] = `${overflowWidth}px`;
                dialog.style.width = `${dialog.offsetWidth - overflowWidth - 10}px`;
            }
            if (rect.bottom > window.innerHeight) {
                let overflowHeight = rect.bottom - window.innerHeight;
                inset[0] = `${overflowHeight}px`;
                dialog.style.height = `${dialog.offsetHeight - overflowHeight - 10}px`;
            }

            // Apply the new inset to the dialog
            dialog.style["inset"] = `${inset[0]} auto auto ${inset[3]}`;
        }

        setStartingPosition() : void {
            setTimeout(() => {
                var localStorageData = this.getLocalStorageData();
                if (localStorageData && localStorageData.lastPosition) {
                    let dialog = $('#ai-chat-modal');
                    dialog.css({
                        'inset': localStorageData.lastPosition,
                        'width': `${localStorageData.width}px`,
                        'height': `${localStorageData.height}px`
                    });

                    this.adjustDialogPositionAndSize(dialog[0]);
                }
            }, 500);
        }

        getLocalStorageData() : any {
            try {
                var json = JSON.parse(localStorage.getItem(this.localStorageKey)) || {};
                return json;
            } catch (error) {
                return null;
            }
        }

        updateLastPosition(insetValue) {
            try {
                var json = JSON.parse(localStorage.getItem(this.localStorageKey)) || {};
                json.lastPosition = insetValue;
                json.width = $('#ai-chat-modal').width();
                json.height = $('#ai-chat-modal').height();
                this.saveLocalStorageItem(json);
            } catch (error) {

            }
        }

        saveLocalStorageItem(obj) {
            try {
                localStorage.setItem(this.localStorageKey, JSON.stringify(obj));
            } catch (error) { }
        }

        makeDialogDraggable(wrapper) {
            $('#' + wrapper).draggable({
                handle: '.ai-chat-toolbar',
                containment: document.querySelector('body'),
                start: () => {
                    if (this.isResizing) {
                        return false;
                    }
                    $(this).css({ cursor: 'pointer', transition: 'none' });
                },
                drag: () => {
                    $(this).css({ cursor: 'grabbing' });
                },
                stop: (event) => {
                    $(this).css({ cursor: 'pointer', transition: '' });
                    this.updateLastPosition($(event.target).css("inset"));
                }
            });
        }


        touchHandler(event) {
            var touch = event.changedTouches[0];

            var simulatedEvent = document.createEvent("MouseEvent");
                simulatedEvent.initMouseEvent({
                touchstart: "mousedown",
                touchmove: "mousemove",
                touchend: "mouseup"
            }[event.type], true, true, window, 1,
                touch.screenX, touch.screenY,
                touch.clientX, touch.clientY, false,
                false, false, false, 0, null);

            touch.target.dispatchEvent(simulatedEvent);
            event.preventDefault();
        }

        enableTouchSupport(el: HTMLElement) {
            el.addEventListener("touchstart", this.touchHandler, true);
            el.addEventListener("touchmove", this.touchHandler, true);
            el.addEventListener("touchend", this.touchHandler, true);
            el.addEventListener("touchcancel", this.touchHandler, true);
        }

        addResizeListeners(): void {
            let initialWidth = 0;
            let initialHeight = 0;
            let lastDownX = 0;
            let lastDownY = 0;

            const resize = (e) => {
                if (!this.isResizing) {
                    return;
                }

                let clientX, clientY;

                if (e.type === 'touchmove') {
                    clientX = e.touches[0].clientX;
                    clientY = e.touches[0].clientY;
                } else {
                    clientX = e.clientX;
                    clientY = e.clientY;
                }

                let moveX = clientX - lastDownX;
                let moveY = clientY - lastDownY;

                let dialog = $('#ai-chat-modal')[0];
                if (dialog) {
                    let newWidth = initialWidth + moveX;
                    dialog.style.width = newWidth + "px";

                    let newHeight = initialHeight + moveY;
                    newHeight = Math.max(newHeight, this.MIN_HEIGHT);
                    dialog.style.height = newHeight + "px";

                }
            }

            const stopResizing = (e) => {
                this.isResizing = false;
                window.removeEventListener('mousemove', resize);

                let dialog = $('#ai-chat-modal');
                if (dialog.length > 0) {
                    this.adjustDialogPositionAndSize(dialog[0]);
                }
            }

            const onMouseDown = (e) => {
                this.isResizing = true;
                let dialog = $('#ai-chat-modal')[0];
                initialWidth = dialog.offsetWidth;
                initialHeight = dialog.offsetHeight;
                lastDownX = e.clientX;
                lastDownY = e.clientY;

                window.addEventListener('mousemove', resize);
            };

            this.resizeHandle.addEventListener('mousedown', onMouseDown);

            window.addEventListener('mouseup', stopResizing);
            window.addEventListener('mouseleave', stopResizing);
        }


    }

    angular.module("meevo.components.aichat")
        .controller("meevo.components.aichat.AiChatModalController", AiChatModalController);
}
